import { Layout } from "../components/Layout"
import { AboutUs } from "../components/sections/AboutUs"
import { Brands } from "../components/sections/Brands"
import { CTA } from "../components/sections/CallToAction"
import { Hero } from "../components/sections/Hero"
import { Pricing } from "../components/sections/Pricing"
import { Services } from "../components/sections/Services"

export const LandingPage = () => {
  return (
    <Layout title="TurboDVM">
      <Hero />
      <Services />
      <AboutUs />
      <Pricing />
      <Brands />
      <CTA />
    </Layout>
  )
}
